/**
 * Envia os bytes de um anexo para a URL assinada que `createAttachmentUpload`
 * devolveu.
 *
 * Este e o unico lugar da SPA fora do mutator que fala `fetch`, e a excecao esta
 * declarada em `eslint.config.js` com escopo de um arquivo so. A razao da regra
 * — "chamada HTTP escrita a mao **contra a plataforma** e recusada, porque o
 * cliente e gerado do contrato" — nao alcanca este `PUT`: o destino nao e a API,
 * e sim o object storage, por uma URL que o proprio servidor emitiu e assinou.
 * Nao existe operacao de contrato para gerar cliente, entao nao ha de que
 * divergir.
 *
 * Mandar os bytes pelo mutator seria pior: ele injeta `Accept-Language`,
 * `Content-Type: application/json` e `credentials: 'include'` — ou seja, o
 * cookie de sessao — num host que nao e o nosso.
 */
export async function uploadToSignedUrl(url: string, file: File): Promise<void> {
  const response = await fetch(url, {
    method: 'PUT',
    body: file,
    headers: { 'Content-Type': file.type },
    // Explicito, e nao por default: nenhuma credencial da plataforma sai daqui.
    credentials: 'omit',
  });

  if (!response.ok) {
    throw new Error(`upload recusado pelo armazenamento: ${response.status}`);
  }
}
